import { Outlet } from "react-router-dom";
import LoginCheck from "./LoginCheck"
const adminLayout = () => {
    return (
        <LoginCheck>
            <Outlet />
        </LoginCheck>
    );
};
export default adminLayout;